module.exports = {
	/**
	 * @type {string}
	 * @description 首页三张背景图
	 */
	bg1: 'https://s3.tebi.io/xmyr/common/bg1.jpg',
	bg2: 'https://s3.tebi.io/xmyr/common/bg2.jpg',
	bg3: 'https://s3.tebi.io/xmyr/common/bg3.jpg',

	/**
	 * @type {string}
	 * @description 首页故障风文字
	 */
	malfunctionText: '寻梦依然的个人空间'
}
